import CreateNewOrderModal from "./CreateNewOrderModal";

export default CreateNewOrderModal;